import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AuthorizationGuard } from './authorization-guard';

import { AppComponent } from './app.component';
import { BajaComponent } from './home/baja.component';
import { AveriasComponent } from './home/averias.component';
import { ContactComponent } from './home/contact.component';
import { HomeComponent } from './home/home.component';
import { DatosCorrespondenciaComponent } from './home/datoscorrespondencia.component';
import { ConsumofacturaComponent } from './home/consumofactura.component';
import { FaqComponent } from './home/faq.component';
import { GraficoComponent } from './home/Components/grafico.component';
import { FaqGuadalaguaComponent } from './home/Faqs/faqGuadalagua.component';
import { FaqSoriaComponent } from './home/Faqs/faqSoria.component';
import { FaqValorizaComponent } from './home/Faqs/faqValoriza.component';
import { UploadFileComponent } from './home/Components/uploadfile.component';
import { CalendarioComponent } from './home/Components/calendario.component';
import { ChangePasswordComponent } from './home/changePassword.component';
import { SimuladorConsumoComponent } from './home/simuladorConsumo.component';
import { UsuarioComponent } from './home/usuario.component';
import { DomiciliacionFacturaComponent } from './home/domiciliacionFactura.component';
import { LecturaContadorComponent } from './home/lecturacontador.component';
import { LoginComponent } from './public/login.component';
import { RegisterComponent } from './public/register.component';
import { ContactpublicComponent } from './public/contactpublic.component';
import { MainComponent } from './public/main.component';
import { ResetPasswordComponent } from './public/resetPassword.component';

import { SessionService } from './services/session.service';

import { GoogleAnalyticsService } from './services/google-analytics.service';
import { FaqEmmasaComponent } from './home/Faqs/faqEmmasa.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared.module';
import { MaterialModule } from './material.module';

@NgModule({
  declarations: [
    AppComponent,
    ContactpublicComponent,
    LoginComponent,
    MainComponent,
    RegisterComponent,
    ResetPasswordComponent,
    AveriasComponent,
    BajaComponent,
    ChangePasswordComponent,
    ConsumofacturaComponent,
    ContactComponent,
    DatosCorrespondenciaComponent,
    DomiciliacionFacturaComponent,
    FaqComponent,
    HomeComponent,
    LecturaContadorComponent,
    SimuladorConsumoComponent,
    UsuarioComponent,
    CalendarioComponent,
    GraficoComponent,
    UploadFileComponent,
    FaqEmmasaComponent,
    FaqGuadalaguaComponent,
    FaqSoriaComponent,
    FaqValorizaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule
  ],
  exports: [
    MaterialModule,
  ],
  providers: [
    SessionService,
    AuthorizationGuard,
    GoogleAnalyticsService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(protected _googleAnalyticsService: GoogleAnalyticsService) { } // We inject the service here to keep it alive whole time

}
